import { SerializedError } from '@reduxjs/toolkit';
import { FetchBaseQueryError } from '@reduxjs/toolkit/dist/query';

export type MutationError = { error: FetchBaseQueryError | SerializedError };

export function isMutationError(result: unknown): result is MutationError {
	if ((result as { error: FetchBaseQueryError | SerializedError }).error) {
		return true;
	}
	return false;
}
